module.exports = __webpack_public_path__ + "static/media/8.5x11no2-min.c15ed841.jpg";